import cn from '@/lib/cs';
import { memo } from 'react';

const SectionBackground = memo(({ className }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 360 172"
		className={cn(
			'absolute inset-0 size-full pointer-events-none',
			className
		)}
		preserveAspectRatio="none"
	>
		<path
			fill="currentColor"
			d="M0 6s71-7 123-6l237 6v163s-50 3-98 3L0 169V6z"
		/>
	</svg>
));

export const LargeSectionBackground = memo(
	({ className }: { className?: string }) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 360 419"
			className={cn(
				'absolute inset-0 size-full pointer-events-none',
				className
			)}
			preserveAspectRatio="none"
		>
			<path
				fill="currentColor"
				d="M0 415.4s7.5 5.5 122.5 3c115-2.6 237.5 0 237.5 0V6.3S230 1 182 1 0 6.5 0 6.5v408.9Z"
			/>
		</svg>
	)
);

export default SectionBackground;
